import { useRef, useState, useEffect } from 'react';
import { Typography } from '@mui/material';
import { Tooltip } from 'framework/ui/mui-builder';
import { FieldProps, useFieldHelper } from 'framework/ui/field';
import { EMPTY_VALUE_INDICATOR } from 'framework/utils';

const NotesField = (props: FieldProps) => {
  const { getValue } = useFieldHelper<string>({ source: props.source });
  const value = getValue();
  const textRef = useRef<HTMLElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const el = textRef.current;
    if (el) {
      setIsTruncated(el.scrollWidth > el.clientWidth);
    }
  }, [value]);

  if (!value) {
    return <Typography variant="body1">{EMPTY_VALUE_INDICATOR}</Typography>;
  }

  const textElement = (
    <Typography ref={textRef} variant="body1" noWrap pr={1}>
      {value}
    </Typography>
  );

  if (!isTruncated) {
    return textElement;
  }

  return (
    <Tooltip title={value} placement="bottom">
      <span>{textElement}</span>
    </Tooltip>
  );
};

export default NotesField;
